<!-- 目的地 -->
<template>
  <div class="destination" style="background-color: #fff;">
    <Top></Top>
    <Rotation :type="lbt"></Rotation>

    <div id="middleCon">
      <!-- 热门目的地影像馆 -->
      <div class="goodeVideo">
        <h2>热门目的地影像馆</h2>
        <p class="top-p" style="color: rgb(163, 151, 60);">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</p>
      </div>

      <div class="videoBox1">
        <div class="box1">
          <div class="top">
            <img :src="(homeList[0].headimage && homeList[0].headimage.substring(0, 4) == 'http') ? homeList[0].headimage : 'https://www.yunshangzg.com/' + homeList[0].headimage
              " alt="">
            <p>{{ homeList[0].username }}</p>
            <div class="look" @click="goHome(homeList[0].idOrLink)">立即查看</div>
          </div>

          <el-carousel trigger="click" style="position: relative;">
            <el-carousel-item @click="goHome(homeList[0].idOrLink)" v-for="item in homeList[0].showPhoto" :key="item">
              <img @click="goHome(homeList[0].idOrLink)" :src="item + '?x-oss-process=image/resize,h_800'" />
            </el-carousel-item>
          </el-carousel>

        </div>
        <div class="box2" @click="goHome(item.idOrLink)" v-for="item in homeList.slice(1)" :key="item">
          <img :src="item.showPhoto + '?x-oss-process=image/resize,h_300'" alt="">
          <div class="name">{{ item.username }}</div>
          <div class="msk"></div>
        </div>
      </div>

      <div class="xBox2">
        <div class="item" @click="goHome(item.idOrLink)" v-for="(item, index) in wordList" :key="index">
          <div class="img">
            <img
              :src="(item.headimage && item.headimage.substring(0, 4) == 'http') ? item.headimage : 'https://www.yunshangzg.com/' + item.headimage"
              alt="">
          </div>
          <div class="text">
            <div class="name">{{ item.username }}</div>
          </div>
        </div>
      </div>
      <div class="goodeVideo">
        <h2>区域</h2>
        <p class="top-p" style="color: rgb(163, 151, 60);">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</p>
      </div>

      <!-- 地图 -->
      <chinaMap />

      <!-- 地址tabs -->
      <addressTabs />
    </div>


    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>

    <service />
    <shopFloat />

    <Foot></Foot>
  </div>
</template>
<script>
import chinaMap from '@/components/chinaMap.vue'
import { setLocalStorage } from "../utils/auth";
import { getLocalStorage } from "../utils/auth";
import { setToken } from "../utils/auth";
import addressTabs from '@/components/addressTabs'
import Top from "../components/top";
import Rotation from "../components/rotation.vue";
import Foot from "../components/foot.vue";
var justifiedLayout = require("justified-layout");
export default {
  components: { Top, Rotation, Foot, addressTabs, chinaMap },
  name: "destination",
  data() {
    return {
      lbt: 'yxg',//传给子组件用来区别轮播图
      urlList: [
        "http://localhost:3000/attchments/work/2020619/1592560044555-自在如风的少年.jpg",
        "http://localhost:3000/attchments/work/2020619/1592560325880-磊-重庆场.jpg",
      ],
      dataAr: [],
      dataArr: [],
      user_url: "",
      page: 1,
      isactive: true,
      actindex: 1,
      cityList: ["杭州", "杭州", "杭州", "杭州", "杭州", "杭州", "杭州"],
      cityname: "",
      destinationList: [
        "西湖风景名胜区",
        "西湖风景名胜区",
        "西湖风景名胜区",
        "西湖风景名胜区",
      ],
      districtList: ["上城区", "上城区", "上城区", "上城区"],
      tags: [],
      homeList: [],  //热门目的地影像馆数据
      wordList: [],//文字位
    };
  },
  created() {
    this.getHomeList()
    this.getWordList()
  },
  methods: {



    async getHomeList() {
      const res = await this.$axios.get('/homeReception/findImageShop', { params: { commendType: 5 } })
      this.homeList = res.data
    },


    async getWordList() {
      const res = await this.$axios.get('/homeReception/findWord', { params: { commendType: 5 } })
      this.wordList = res.data
    },

    // 点击去影像馆
    goHome(id) {
      let { href } = this.$router.resolve({
        path: "/destinationHome",
        query: {
          id
        }
      })
      const newWindowName = "newTab_" + Date.now();
      window.open(href, newWindowName)
    }


  },
};
</script>
<style scoped lang="scss">
// @media screen and (min-width: 375px) and (max-width: 1456px) {
//   #middleCon {
//     width: 100% !important;
//     padding: 10px !important;

//     .goodeVideo {
//       width: 100% !important;
//     }

//     .videoBox1 {
//       width: 100% !important;
//       height: 900px !important;

//       .box1 {
//         width: 930px !important;
//         height: 568px !important;
//       }

//       .box2 {
//         width: 453px !important;
//         height: 275px !important;
//       }
//     }

//     .xBox2 {
//       .item {
//         width: 400px !important;
//         height: 120px !important;
//       }
//     }
//   }
// }


#middleCon {
  width: 1600px;
  margin: 0 auto;
}


/deep/ .el-carousel__button {
  display: block;
  width: 8px;
  height: 8px;
  background: #f5f5f5;
  border-radius: 50%;
  opacity: 0.7;
  border: 0 !important;
  border-radius: 50%;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
}

/deep/ .el-carousel__indicator.is-active button {
  width: 22px;
  height: 7px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 6px;
}

#home {
  border: none;
  padding-top: 15px;
  overflow-y: hidden;
  overflow-x: hidden;
}


//  <!-- 热门目的地影像馆 -->
.goodeVideo {
  width: 100%;
  height: 30px;
  margin: 52px auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  h2 {
    font-size: 24px;
    font-weight: bold;
  }
}

// 盒子1
.videoBox1 {
  width: 100%;
  // height: 600px;
  // margin: 10px auto;

  .box1 {
    overflow: hidden;
    width: 946px;
    height: 404px;
    // width: 620px;
    // height: 364px;
    float: left;
    margin-right: 14px;
    margin-bottom: 15px;
    position: relative;
    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
    background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
    background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
    background-size: 400% 100%;

    /deep/ .el-carousel {
      width: 100%;
      height: 100%;
    }

    /deep/ .el-carousel__container {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .box2 {
    overflow: hidden;
    margin-right: 15px;
    margin-bottom: 15px;
    float: left;
    width: 305px;
    height: 195px;
    position: relative;
    /* 以下代码实现背景动画效果 */
    animation: loading 1.4s ease infinite;
    -webkit-animation: loading 1.4s ease infinite;
    background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
    background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
    background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
    background-size: 400% 100%;

    &:nth-child(3) {
      margin-right: 0;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }



    .name {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
      color: #fff;
      z-index: 9999999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .msk {
      position: absolute;
      top: 0%;
      left: 0%;
      width: 100%;
      height: 100%;
      z-index: 9;
      transition: all .3s;
      background-color: rgba(0, 0, 0, .2);

      &:hover {
        background-color: rgba(0, 0, 0, .3);
      }
    }

    img {

      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

}

// 轮播图头部
.top {
  position: absolute;
  top: 0;
  left: 0;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  color: #FFFFFF;
  z-index: 777;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  p {
    flex: 1;
    padding-left: 13px;
    font-size: 18px;
  }

  .look {
    width: 120px;
    height: 36px;
    border-radius: 20px;
    border: 2px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}




.xBox2 {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    width: 300px;
    height: 80px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    overflow: hidden;
    padding-left: 10px;
    cursor: pointer;

    &:hover {
      border-radius: 8px;
      -webkit-box-shadow: 0 3px 10px rgba(34, 33, 33, 0.2);
    }

    .img {
      width: 55px;
      height: 55px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .text {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 15px;
      height: 60px;
      font-size: 12px;
      color: #737373;

      .name {
        font-size: 18px;
        color: #000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/destination.vue